import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { ReferenceDataCategoriesConstants } from '../constants/reference-data-categories';
import { ReferenceDataService } from './reference-data.service';

@Injectable()
export abstract class BaseUserSessionService {
  protected readonly millisecondsInMinute = 60_000;
  protected readonly session$ = new Subject();

  private hasStopped = true;

  public logout$: Observable<unknown>;
  public logoutWarning$: Observable<unknown>;

  protected abstract userSessionDurationInMinutesConfig;
  protected abstract userSessionAboutToExpireDeltaInMinutesConfig;

  constructor(
    protected readonly referenceDataService: ReferenceDataService,
    protected readonly httpClient: HttpClient
  ) {}

  protected abstract checkSession(): Observable<Object>;

  public restartSession(): void {
    this.session$.next();
    this.hasStopped = false;
  }

  public stopSession(): void {
    this.hasStopped = true;
  }

  public confirmConnectionToServer(): void {
    this.checkSession().subscribe(() => {
      this.session$.next();
    });
  }

  public initialize(): void {
    const userSessionDurationInMinutes = +this.referenceDataService.getConfigurationValue(
      ReferenceDataCategoriesConstants.CLIENT_ENVIRONMENT_CATEGORY,
      this.userSessionDurationInMinutesConfig
    );
    const userSessionAboutToExpireDeltaInMinutes = +this.referenceDataService.getConfigurationValue(
      ReferenceDataCategoriesConstants.CLIENT_ENVIRONMENT_CATEGORY,
      this.userSessionAboutToExpireDeltaInMinutesConfig
    );

    this.logoutWarning$ = this.session$.pipe(
      debounceTime(userSessionAboutToExpireDeltaInMinutes * this.millisecondsInMinute),
      filter(() => !this.hasStopped)
    );

    this.logout$ = this.session$.pipe(
      debounceTime(userSessionDurationInMinutes * this.millisecondsInMinute),
      filter(() => !this.hasStopped)
    );
  }
}
